import type { FieldsType } from 'contentful'

type EntryInlineProps = {
  asset: {
    fields: FieldsType
  }
}

export const EntryInline = ({ asset }: EntryInlineProps) => {
  const { title, description } = asset.fields || { fields: {} }
  return (
    <div className="flex flex-col rounded-3xl m-12 gap-6 bg-green-10 pt-2 px-6 pb-9">
      <h4 className="text-s text-green-60">{title}</h4>
      <p className="text-xs text-green-60">{description}</p>
    </div>
  )
}
